<template>
  <div>
    <div class="columns pb-3">
      <div class="column">
        <b-field label="Tipo de servicio">
          <b-input
            placeholder="Tipo servicio"
            type="text"
            name="fullName"
            v-model="service.serviceType.title"
            readonly="readonly"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Tipo de mensual *">
          <b-select placeholder="Tipo mensual" expanded v-model="incomeType">
            <option
              v-for="type in incomeTypeList"
              :value="type"
              :key="type.code"
              :id="type.code"
            >
              {{ type.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Fecha inicial">
          <b-datepicker
            name="initialDate"
            v-model="service.initialDate"
            placeholder="Seleccione una fecha..."
            icon="calendar-today"
            :date-formatter="formatDate"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Fecha final">
          <b-datepicker
            name="finalDate"
            v-model="service.finalDate"
            placeholder="Seleccione una fecha..."
            :date-formatter="formatDate"
            icon="calendar-today"
            :min-date="service.initialDate"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Liquidación*">
          <b-select
            placeholder="Liquidación"
            expanded
            v-model="service.liquidation"
          >
            <option
              v-for="liquidation in liquidationList"
              :value="liquidation"
              :key="liquidation.code"
              :id="liquidation.code"
            >
              {{ liquidation.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Horario*">
          <b-select
            placeholder="Horario"
            expanded
            v-model="service.schedule"
            name="conceptType"
          >
            <option
              v-for="option in scheduleList"
              :value="option"
              :key="option.code"
              :id="option.code"
            >
              {{ option.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Cantidad de cupos*">
          <b-input v-model="quotaValue" type="number" @blur="validateQuota" />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Pagar individual">
          <vs-switch v-model="isIndividual" />
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Lote*">
          <b-select
            placeholder="Seleccione un lote"
            expanded
            v-model="service.slot"
            name="conceptType"
          >
            <option
              v-for="slotInfo in slotList"
              :value="slotInfo"
              :key="slotInfo.code"
              :id="slotInfo.code"
            >
              {{ slotInfo.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <slot name="extraFields"></slot>
      <div class="column is-3">
        <b-field label="Valor del servicio *">
          <b-input
            placeholder="Valor"
            type="text"
            v-model="service.total"
            readonly="readonly"
            icon="currency-usd"
          />
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Periodicidad">
          <treeselect
            placeholder="Seleccione la periodicidad"
            expanded
            :options="periodicities"
            v-model="service.periodicity"
            name="typeUse"
          />
        </b-field>
        <span class="show-error">{{ errors.first('duration') }}</span>
      </div>

      <div class="column is-3" v-if="showMultiparking">
        <b-field label="Multiparqueadero">
          <vs-switch v-model="service.isMultiparking" />
        </b-field>
      </div>

      <div class="column is-3">
        <b-field label="Restricción placa" v-if="showPlateRestriction">
          <b-select
            placeholder="Seleccione una opción"
            expanded
            v-model="service.plateRestriction"
            name="plateRestriction"
          >
            <option value="" v-if="getValidArray(plateRestrictionList).length === 0">No hay opciones para mostrar</option>

            <option
              v-for="prItem in getValidArray(plateRestrictionList)"
              :value="prItem"
              :key="prItem.id"
              :id="prItem.id"
            >
              {{ prItem.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-3" v-if="isPostpaid">
        <b-field label="Horas de parqueo Postpago">
          <b-input
            placeholder="Ingrese número de horas"
            type="number"
            v-model="postPaidHours"
          />
        </b-field>
      </div>
      <div class="column flex-end">
        <b-button @click="addItem()" type="is-info"> Agregar item</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import unityEndpoint from '@/endpoints/core/UnityEndpoint'
import kind from '@/global/lasting/EKind'
import liquidationEndpoint from '@/endpoints/billing/LiquidationEndpoint'
import liquidationType from '@/global/lasting/ELiquidationType'
import slotEndpoint from '@/endpoints/core/SlotEndpoint'
import scheduleEndpoint from '@/endpoints/income/ScheduleEndpoint'
import scheduleType from '@/global/lasting/EScheduleType'
import DateUtils from '@/global/DateUtils'
import toast from '@/global/ToastConfig'
import { isGreaterThan } from '@/global/utils'
import settingsEndPoint from '@/endpoints/core/SettingsEndpoint'
import { getValidArray as getValidArrayFn } from '@/helpers/arrays'

export default {
  name: 'GeneralService',
  props: {
    companyId: Number,
    service: Object,
    showMultiparking: {
      type: Boolean,
      default: false,
    },
    showPlateRestriction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      plateRestrictionList: [],
      incomeTypeList: [],
      liquidationList: [],
      slotList: [],
      scheduleList: [],
      isIndividual: false,
      quotaValue: this.service.quota,
      forceRender: 0,
      periodicities: [
        { label: 'Mensual', id: 'MONTHLY' },
        { label: 'Quincenal', id: 'BIWEEKLY' },
        { label: 'Días', id: 'DAILY' },
      ],
      isPostpaid: false,
      incomeType: null,
      postPaidHours: 0,
    }
  },
  mounted() {
    this.incomeType = this.service.incomeType
    unityEndpoint
      .getUnityListByKind(kind.INCOME_TYPES, 'mensualidad')
      .then((info) => (this.incomeTypeList = info))

    this.launchQueries()
    
    const isPartial = this.service.isPartial
    this.isIndividual = isPartial && 'YES' === isPartial
  },
  watch: {
    isIndividual() {
      this.service.isPartial = this.isIndividual ? 'YES' : 'NO'
      this.confirmIndividual()
    },
    quotaValue(newValue, oldValue) {
      if (newValue === '') {
        return
      }
      if (!isGreaterThan(newValue, 1)) {
        this.quotaValue = oldValue || 1
      }
      this.service.quota = this.quotaValue
    },
    incomeType() {
      this.service.incomeType = this.incomeType
      this.validatePostPaid()
    },
    postPaidHours() {
      this.service.postPaidHours = this.postPaidHours
    },
  },
  methods: {
    getValidArray(array) {
      return getValidArrayFn(array);
    },
    launchQueries(){
      settingsEndPoint.getRestrictedDrivingOptions({companyCode: this.companyId})
      .then(({info}) => {
        this.plateRestrictionList = info
      })

      liquidationEndpoint
      .listByLiquidationType(
        liquidationType.LIQUIDATION_MONTHLY,
        this.companyId
      )
      .then((info) => {
        this.liquidationList = info
        const initial = this.service.liquidation
        if (initial) {
          this.service.liquidation = this.liquidationList.find(
            (item) => item.code === initial.code
          )
        }
      })
    slotEndpoint.listByCompany(this.companyId).then((info) => {
      this.slotList = info
      const initial = this.service.slot
      if (this.service.slot) {
        this.service.slot = this.slotList.find(
          (item) => item.code === initial.code
        )
      }
    })
    scheduleEndpoint
      .findByTypeAndCompany(scheduleType.SCHEDULE_MONTHLY, this.companyId)
      .then((info) => {
        this.scheduleList = info
        const initial = this.service.schedule
        if (initial) {
          this.service.schedule = this.scheduleList.find(
            (item) => item.code === initial.code
          )
        }
      })
    },
    confirmIndividual() {
      if (this.isIndividual) return
      const itemList = this.service.itemList
      if (itemList.length <= 0) return
      toast
        .ask(
          this,
          '¿Está seguro? se van a actualizar todos los items con la fecha final del servicio'
        )
        .then((result) => {
          if (!result) {
            this.isIndividual = true
            return
          }
          itemList.forEach((item) => (item.finalDate = this.service.finalDate))
        })
    },
    validateQuota() {
      if (!this.service.quota || this.quotaValue < 1) {
        toast.error('Cantidad de cupos es mayor o igual 1')
        this.quotaValue = 1
      }
      this.service.quota = this.quotaValue
    },
    addItem() {
      this.$emit('addItem')
    },
    formatDate(a) {
      return DateUtils.toDateShortString({ date: a, timezone: '' })
    },
    validatePostPaid() {
      this.isPostpaid = false
      if (!this.incomeType) {
        this.isPostpaid = false
        return
      }
      if (this.incomeType.initials === 'POST') {
        this.isPostpaid = true
      }
    },
  },
}
</script>

<style scoped>
.columns {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
}

.column {
  width: 100%;
  display: flex;
}

.column .field {
  width: 100%;
}

.column.flex-end {
  align-items: flex-end;
}
</style>
